import PropTypes from 'prop-types';
import { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useImage } from 'react-image';
import classNames from 'classnames';

import SkeletonImage from '@febos-io/design/src/components/Skeleton/SkeletonImage';

import usePreSignedUrlDownloadCallback from '../hooks/usePreSignedUrlDownloadCallback';

export function ImageS3({
  src,
  alt,
  className,
  ...props
}) {
  const { callback, loading, url } = usePreSignedUrlDownloadCallback();

  useEffect(() => {
    callback({ file: src });
  }, [callback, src]);

  return (
    <div
      role="button"
    >
      {!loading ? (
        <img
          src={url}
          alt={alt}
          className={classNames('object-fit-cover', className)}
          {...props}
        />
      ) : (
        <SkeletonImage />
      )}
    </div>
  );
}

ImageS3.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  ...useImage.propTypes
};

export default ImageS3;
